import React, { Component } from 'react';
import { AppBar, Card, Divider, Typography, Icon, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as instructorActions from '../../instructor/store/actions';
import BigCalendar from 'react-big-calendar';

const localizer = BigCalendar.momentLocalizer(moment);

const styles = theme => ({
    root: {
        display: 'flex',
        position: 'relative',
        flexDirection: 'column',
        flex: 1,
        '& .rbc-header': {
            padding: '12px 6px',
            fontWeight: 500,
            fontSize: 14

        },
        '& .rbc-label': {
            padding: '8px 6px'
        },
        '& .rbc-today': {
            backgroundColor: 'transparent'
        },
        '& .rbc-header.rbc-today, & .rbc-month-view .rbc-day-bg.rbc-today': {
            borderBottom: '2px solid ' + theme.palette.secondary.main + '!important'
        },
        '& .rbc-month-view, & .rbc-time-view, & .rbc-agenda-view': {
            padding: 24,
            ...theme.mixins.border(0)
        },
        '& .rbc-agenda-view table': {
            ...theme.mixins.border(1),
            '& thead > tr > th': {
                ...theme.mixins.borderBottom(0)
            },
            '& tbody > tr > td': {
                padding: '12px 6px',
                '& + td': {
                    ...theme.mixins.borderLeft(1)
                }
            }
        },
        '& .rbc-time-view': {
            '& .rbc-time-header': {
                // ...theme.mixins.border(1)
                display: 'none'
            },
            '& .rbc-time-content': {
                flex: '0 1 auto',
                ...theme.mixins.border(1),
                overflowY: 'hidden',
                overflowX: 'hidden'
            }
        },
        '& .rbc-month-view': {
            '& > .rbc-row': {
                ...theme.mixins.border(1)
            },
            '& .rbc-month-row': {
                ...theme.mixins.border(1),
                borderWidth: '0 1px 1px 1px!important',
                minHeight: 128
            },
            '& .rbc-header + .rbc-header': {
                ...theme.mixins.borderLeft(1)
            },
            '& .rbc-header': {
                ...theme.mixins.borderBottom(0)
            },
            '& .rbc-day-bg + .rbc-day-bg': {
                ...theme.mixins.borderLeft(1)
            }
        },
        '& .rbc-day-slot .rbc-time-slot': {
            ...theme.mixins.borderTop(1),
            opacity: 0.5,
        },
        '& .rbc-time-header > .rbc-row > * + *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-content > * + * > *': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-day-bg + .rbc-day-bg': {
            ...theme.mixins.borderLeft(1)
        },
        '& .rbc-time-header > .rbc-row:first-child': {
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-timeslot-group': {
            minHeight: 64,
            ...theme.mixins.borderBottom(1)
        },
        '& .rbc-date-cell': {
            padding: 8,
            fontSize: 16,
            fontWeight: 400,
            opacity: .5,
            '& > a': {
                color: 'inherit'
            }
        },
        '& .rbc-event': {
            borderRadius: 0,
            // padding: '4px 8px',
            backgroundColor: theme.palette.primary.dark,
            minHeight: '30px',
            color: theme.palette.primary.contrastText,
            boxShadow: theme.shadows[0],
            transitionProperty: 'box-shadow',
            transitionDuration: theme.transitions.duration.short,
            transitionTimingFunction: theme.transitions.easing.easeInOut,
            position: 'relative',
            '&:hover': {
                boxShadow: theme.shadows[2]
            }
        },
        //Connor
        '& .rbc-event-label': {
            display: 'none'
        },
        '& .rbc-day-slot .rbc-event': {
            minHeight: '30px'
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-off-range-bg': {
            backgroundColor: theme.palette.type === 'light' ? 'rgba(0,0,0,0.03)' : 'rgba(0,0,0,0.16)'
        },
        '& .rbc-show-more': {
            color: theme.palette.secondary.main,
            background: 'transparent'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event': {
            position: 'static'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:first-child': {
            left: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-resizable-month-event .rbc-addons-dnd-resize-month-event-anchor:last-child': {
            right: 0,
            top: 0,
            bottom: 0,
            height: 'auto'
        },
        '& .rbc-toolbar-label': {
            display: 'none'
        },
        '& .rbc-btn-group': {
            display: 'none'
        }
    }
});

class InstructorTodaySchedule extends Component {

    constructor(props) {
        super(props);

        this.props.getDayEvents(this.props.auth.user.data.role_info.link_id, moment(new Date()).format('YYYY-MM-DD'))
    }

    eventStyleGetter = (event, start, end, isSelected) => {
        let style = { backgroundColor: event.Color }
        return { style: style }
    }

    handleEventSelect = (event) => {
        return this.props.history.push('/grade/student/list/' + event.id)
    }


    render() {
        const { classes, dayEvents } = this.props;
        const dayComponent = ({ event }) => (
            <div>
                <div className='float-left' style={{ paddingTop: '4px' }}>
                    {moment(event.start).format('h:mm A')} - {moment(event.end).format('h:mm A')}
                </div>

                <div className='float-right'>
                    {event.title}
                </div>
            </div>
        )

        return (
            <Card className={classNames(classes.root, "w-full")}>
                <AppBar position="static">
                    <div className="p-16 pr-4 flex flex-row items-center justify-between">
                        <Typography className="h1 pr-16" color="inherit"> {moment(new Date).format('MMM Do, YYYY')}</Typography>
                    </div>
                </AppBar>
                <BigCalendar
                    components={{ day: { event: dayComponent } }}
                    defaultView='day'
                    localizer={localizer}
                    events={dayEvents}
                    min={new Date(moment().startOf('day').add(6, 'hours'))}
                    max={new Date(moment().startOf('day').add(18, 'hours'))}
                    step={30}
                    eventPropGetter={(this.eventStyleGetter)}
                    onSelectEvent={(e) => this.handleEventSelect(e)}
                />

                <Divider className="card-divider w-full" />
            </Card>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getDayEvents: instructorActions.getDayEvents
    }, dispatch);
}

function mapStateToProps({ dashboardApp, auth, instructorApp }) {
    return {
        auth: auth,
        dayEvents: instructorApp.instructors.dayEvents
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstructorTodaySchedule)));



// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/InstructorTodaySchedule.js